import React from 'react';
import { NavLink } from 'react-router-dom';
import './Layout.css';

interface MenuItem {
  to: string;
  label: string;
}

interface MenuGroup {
  title: string;
  items: MenuItem[];
}

const menuGroups: MenuGroup[] = [
  {
    title: '',
    items: [
      { to: '/dashboard', label: 'Dashboard' },
    ],
  },
  {
    title: 'Gestão de Pacientes',
    items: [
      { to: '/pacientes', label: 'Pacientes' },
      { to: '/avaliacao', label: 'Avaliação' },
      { to: '/calculo-nutricional', label: 'Cálculo Nutricional' },
    ],
  },
  {
    title: 'Planos e Acompanhamento',
    items: [
      { to: '/planos', label: 'Planos de refeição' },
      { to: '/adesoes', label: 'Adesão aos Planos' },
      { to: '/diario-alimentar', label: 'Diário Alimentar' },
    ],
  },
  {
    title: 'Agenda e Comunicação',
    items: [
      { to: '/agenda', label: 'Agenda' },
      { to: '/chat', label: 'Chat' },
      { to: '/comunidade', label: 'Comunidade' },
    ],
  },
  {
    title: 'Análises e Relatórios',
    items: [
      { to: '/medicoes', label: 'Medições' },
      { to: '/relatorios', label: 'Relatórios' },
    ],
  },
  {
    title: 'Documentos e Exames',
    items: [
      { to: '/pedido-exames', label: 'Pedido de Exames' },
      { to: '/manipulados', label: 'Manipulados' },
      { to: '/instrucoes-nutricionais', label: 'Instruções Nutricionais' },
      { to: '/conteudo-recebido', label: 'Conteúdo Recebido' },
    ],
  },
  {
    title: 'Administrativo',
    items: [
      { to: '/financeiro', label: 'Financeiro' },
      { to: '/recursos', label: 'Recursos' },
    ],
  },
];

export const Sidebar: React.FC = () => {
  return (
    <aside className="ns-sidebar">
      <div className="ns-sidebar-logo">
        <div className="ns-sidebar-logo-mark">NS</div>
        <div className="ns-sidebar-logo-text">
          <span>NutriSync</span>
          <small>Nutricionista</small>
        </div>
      </div>
      <nav className="ns-sidebar-nav">
        {menuGroups.map((group, groupIndex) => (
          <div key={groupIndex} className="ns-sidebar-group">
            {group.title && (
              <div className="ns-sidebar-group-title">{group.title}</div>
            )}
            <div className="ns-sidebar-group-items">
              {group.items.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={({ isActive }) =>
                    `ns-sidebar-link ${isActive ? 'ns-sidebar-link-active' : ''}`
                  }
                >
                  <span>{item.label}</span>
                </NavLink>
              ))}
            </div>
          </div>
        ))}
      </nav>
    </aside>
  );
};

